import React, { ReactElement } from 'react';
import { Button, ButtonType } from '@digicert/dcone-common-ui';
import { Icon } from '@digicert/dcone-common-ui';
import { faGlobe, faArrowUpRightFromSquare, faServer } from '@fortawesome/pro-light-svg-icons'
import { Environment } from './environmentsMock';
import { getCertCentralCounts } from './certCentralCount';
import { serviceIcon } from '../../shared/helpers/utils';
import { STRINGS } from './environmentsStrings';
import styles from './environments.module.scss';

interface EnvironmentCardProps {
  environment: Environment;
  onSelect: (env: Environment) => void;
}

export const EnvironmentCard = ({ environment, onSelect }: EnvironmentCardProps): ReactElement => {
  const { us, eu } = getCertCentralCounts(environment);
  const hasCertCentral = us > 0 || eu > 0;

  const handleCardClick = () => {
    onSelect(environment);
  };

  const handleAccessClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    // TODO: add access callback — open environment URL or trigger navigation
  };

  return (
    <div className={styles.envCard} onClick={handleCardClick} role="button" tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleCardClick()}
    >
      <div className={styles.cardHeader}>
        <div className={styles.avatarCircle}>
          {environment.name.charAt(0).toUpperCase()}
        </div>
        <div className={styles.cardTitleBlock}>
          <span className={styles.cardTitle}>{environment.name}</span>
          <div className={styles.cardMeta}>
            <span className={styles.metaItem}>
              <Icon icon={faGlobe} size="sm" /> {environment.region}
            </span>
            {hasCertCentral && (
              <span className={styles.metaItem}>
                <Icon icon={faServer} size="sm" />
                {STRINGS.CERTCENTRAL_COUNT(us, eu)}
              </span>
            )}
          </div>
        </div>
        <div className={styles.cardOverflow}>
          {/* TODO: wire up overflow menu items (edit, delete, etc.) */}
        </div>
      </div>

      <div className={styles.cardTags}>
        {environment.applications.map((app) => (
          <span key={app.id} className={styles.productChip}>
            {serviceIcon(app.name)}
            {app.name}
          </span>
        ))}
      </div>

      <div className={styles.cardFooter}>
        <Button
          buttonType={ButtonType.PRIMARY}
          onClick={handleAccessClick}
          icon={<Icon icon={faArrowUpRightFromSquare} />}
        >
          {STRINGS.ACCESS}
        </Button>
      </div>
    </div>
  );
};
